import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row-list" }

import { getCurrentInstance, ref } from 'vue'
import { getWarningRefundOrderListApi, updateRefundSplitAgreeApi } from '@/apis/order'


export default /*@__PURE__*/_defineComponent({
  __name: 'MerchantRefundDialog',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

/*********************************** 特殊退款订单 -- begin **********************************************/
const refundSplitInfo:any = ref({})
const dialogShow = ref(false)
dialogShow.value = false

const onSubmit = async (type: number) => {
    const { code, data, msg } = await updateRefundSplitAgreeApi(refundSplitInfo.value.ft_id, type) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })

    proxy.$message({ type: 'success', message: '操作成功' })
    dialogShow.value = false
}
/*********************************** 特殊退款订单 -- end **********************************************/

/*********************************** 普通退款订单 -- begin **********************************************/
const refundOrderDialog = ref(false)
const refundOrderList = ref<any[]>([])
const closeRefundOrderDialog = () => {
    refundOrderList.value = []
    refundOrderDialog.value = false
}
const refundOrderWarningTimer = () => {
    getWarningRefundOrderListApi().then((res:any) => {
        if (res.data.ft_str) { // 如果有承担方信息，则弹特殊退款订单弹窗
            refundSplitInfo.value = res.data
            dialogShow.value = true
        } else if(res.data.length > 0) {
            refundOrderList.value = res.data
            refundOrderDialog.value = true
        }
        setTimeout(refundOrderWarningTimer, 1000 * 60 * 5)
    })
}
refundOrderWarningTimer()
/*********************************** 普通退款订单 -- end **********************************************/

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      title: "退款订单",
      modelValue: refundOrderDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refundOrderDialog).value = $event)),
      "close-on-click-modal": false,
      "z-index": 1999
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: closeRefundOrderDialog
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("知道了")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: refundOrderList.value,
          stripe: "",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "order_no",
              label: "订单号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "product_name",
              label: "商品名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "spec_name",
              label: "规格"
            }),
            _createVNode(_component_el_table_column, {
              prop: "quantity",
              label: "数量"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "特殊退款",
      modelValue: dialogShow.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogShow).value = $event)),
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmit(2)))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("不同意")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onSubmit(1)))
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("同意")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "align-right",
                span: 4
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("订单号：")
                ])),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 20 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(refundSplitInfo.value.order_no), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "align-right",
                span: 4
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("商品：")
                ])),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 20 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(refundSplitInfo.value.product_name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "align-right",
                span: 4
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("订单总金额：")
                ])),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 20 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(refundSplitInfo.value.total_amount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "align-right",
                span: 4
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("退款原因：")
                ])),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 20 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(refundSplitInfo.value.repund_why), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                class: "align-right",
                span: 4
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("承担方：")
                ])),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 20 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(refundSplitInfo.value.ft_str), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})